import React from 'react';
import {Helmet} from 'react-helmet';

const HomePageJsonSchema = ({articles, canonical}) => {
    const renderedItemList = articles.map((article, index) => {
        return `
                    {
                        "@type": "ListItem",
                        "position": ${index + 1},
                        "url": "${canonical}${article.path}"
                    }
        `;
    });
    return (
        <Helmet>
            <script type="application/ld+json">
                {`
                {
                    "@context": "http://schema.org",
                    "@type": "ItemList",
                    "ItemListElement": [
                        ${renderedItemList}
                    ]
                }
                `}
            </script>
        </Helmet>
    );
};

export default HomePageJsonSchema;
